<template>
  <section class="category">
    <video loop muted playsinline preload="none" class="category__video" ref="categoryVideo">
      <source
        src="@/assets/img/success-ladder/blackAndWhite.mp4"
        type="video/mp4"
      />
    </video>
    <div class="category__background" :style="currentBackground"></div>
    <div class="category__wrapper">
      <SuccessHeader />
      <div class="category__panel">
        <router-link
          :to="helpers.buildRoute({ name: 'SuccessLadder' })"
          class="panel__button-back"
        >
          <span class="panel__button-back_arrow">
            <svg
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M18 9H0.999999M0.999999 9L8.97959 17M0.999999 9L8.97959 1"
                stroke="currentColor"
              />
            </svg>
          </span>
          Назад
          <!-- {{$t('buttons.button_back')}} -->
        </router-link>
        <div class="panel__title">
          <div class="panel__title_text">
            {{ activeCategory.name }}
          </div>
          <img
            :src="activeCategory.image"
            :alt="activeCategory.name"
            class="panel__title_img"
          />
        </div>
      </div>

      <div class="category__search-panel">
        <!-- <select
          id="panel1"
          v-model="selectedMonth.value"
          class="select-panel__year"
          @click="filterClick('Месяц')"
        >
          <option
            v-for="month in monthNames"
            :key="month.value"
            :value="month.value"
            class="select-panel__year_option"
          >
            {{ month.text }}
          </option>
        </select> -->
        <!-- <select
          id="panel2"
          v-model="selectedYear.value"
          class="select-panel__year"
          @click="filterClick('год')"
        >
          <option
            v-for="year in yearOptions"
            :key="year.value"
            :value="year.value"
            class="select-panel__year_option"
          >
            {{ year.text }}
          </option>
        </select> -->
        <div id="panel3">
          <input
            id="panel3"
            type="text"
            v-model="searchName"
            class="select-panel_name"
            :class="{ 'select-panel_error': nameError }"
            placeholder="Поиск по фамилии"
            @focus="filterClick('Поиск по фамилии')"
          />
          <div v-if="nameError" class="select-panel_error">
            Не менее 3-х символов
          </div>
        </div>
        <div
          id="panel4"
          class="select-panel_button"
          :class="{ 'select-panel_button_disabled': !searchName }"
          @click="searchPersons"
        >
          Найти
        </div>
      </div>
      <div class="_my-8" v-if="personsList !== null">
        <div
          v-if="searchName && personsList && personsList.length"
          class="category__search-list"
        >
          <div class="persons__date_persons">
            <div
              v-for="(person, index) in personsList"
              :key="index"
              class="persons__date_person"
              @click="personDetails(person)"
            >
              <div class="persons__date_person_frame">
                <video loop muted playsinline preload="none" class="frame__video">
                  <source
                    src="@/assets/img/success-ladder/stock-footageglow-bright.mp4"
                    type="video/mp4"
                  />
                </video>
                <img
                  :src="person.image"
                  :alt="person.image"
                  class="persons__date_person_img"
                />
                <img
                  :src="activeCategory.image"
                  :alt="activeCategory.name"
                  class="persons__date_person_logo"
                />
              </div>
              <div class="persons__date_person_place">
                {{ person.city }}, {{ person.country }}
              </div>
              <div class="persons__date_person_name" v-html="person.name"></div>
              <div class="persons__date_person_name">
                {{monthNames[parseInt(person.nomination_date.split('-')[1])].text +
          ' ' +
          person.nomination_date.split('-')[0],}}
              </div>
            </div>
          </div>
        </div>
        <div
          v-else-if="searchName && personsList !== null"
          class="category__persons_empty"
        >
          Ничего не найдено, попробуйте изменить параметры поиска
        </div>
      </div>
      <div class="category__persons_block" v-else>
        <div class="category__persons" v-if="personsObject.length">
          <div
            v-for="date in personsObject"
            :key="date.text"
            class="persons__date"
          >
            <div
              class="d-md-flex d-block _pa-4"
              style="background-color: rgba(0, 0, 0, 0.7)"
            >
              <div class="persons__date_text">{{ date.text }}</div>
              <router-link
                class="persons__button"
                :to="{
                  name: 'SuccessDateGroup',
                  params: {
                    locale: currentLocale,
                    date: date.linkDate,
                    categoryID: currentID,
                  },
                }"
              >
                Подробнее
              </router-link>
            </div>

            <div
              class="persons__date_persons"
              v-if="date.persons && date.persons.length"
            >
              <div
                v-for="(person, index) in date.persons"
                :key="index"
                class="persons__date_person"
                @click="personDetails(person)"
              >
                <div class="persons__date_person_frame">
                  <video loop muted playsinline preload="none" class="frame__video">
                    <source
                      src="@/assets/img/success-ladder/stock-footageglow-bright.mp4"
                      type="video/mp4"
                      loading="lazy"
                      decoding="sync"
                      importance="low"
                    />
                  </video>
                  <img
                    :src="person.image"
                    :alt="person.image"
                    loading="lazy"
                    decoding="sync"
                    importance="low"
                    class="persons__date_person_img"
                  />
                  <img
                    :src="activeCategory.image"
                    :alt="activeCategory.name"
                    loading="lazy"
                    decoding="async"
                    importance="low"
                    class="persons__date_person_logo"
                  />
                </div>
                <div class="persons__date_person_place">
                  {{ person.city }}, {{ person.country }}
                </div>
                <div
                  class="persons__date_person_name"
                  v-html="person.name"
                ></div>
              </div>
            </div>
            <!-- <div v-else class="category__persons_null">
              Пока здесь нет лидеров
            </div> -->
          </div>
        </div>
        <div v-else class="category__persons_null">Пока здесь нет лидеров</div>
      </div>

      <SuccessFooter />
    </div>
  </section>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { Trans } from '@/plugins/translation'
import SuccessFooter from '@/components/success-ladder/SuccesFooter.vue'
import SuccessHeader from '@/components/success-ladder/SuccessHeader.vue'

export default {
  name: 'SuccessCategory',
  components: { SuccessHeader, SuccessFooter },
  data() {
    return {
      personsObject: [],
      personsList: null,
      nameError: false,
      page: 0,
      pageSize: 10,
      monthNames: [
        { text: 'Месяц', value: '' },
        { text: 'Январь', value: 1 },
        { text: 'Февраль', value: 2 },
        { text: 'Март', value: 3 },
        { text: 'Апрель', value: 4 },
        { text: 'Май', value: 5 },
        { text: 'Июнь', value: 6 },
        { text: 'Июль', value: 7 },
        { text: 'Август', value: 8 },
        { text: 'Сентябрь', value: 9 },
        { text: 'Октябрь', value: 10 },
        { text: 'Ноябрь', value: 11 },
        { text: 'Декабрь', value: 12 },
      ],
      searchName: '',
      yearMin: 2020,
      currentBackground: 'background-color: transparent',
    }
  },
  async mounted() {
    if (this.$route.params.searchName) {
      this.searchName = this.$route.params.searchName
    }

    await this.getCategory({ id: this.currentID })
    this.currentBackground = `background-color: ${this.category.color}`
    let arr = this.category.dates.map((el) => ({
      text:
        this.monthNames[parseInt(el.month.split('-')[1])].text +
        ' ' +
        el.month.split('-')[0],
      linkDate: `${el.month.split('-')[1]}-${el.month.split('-')[0]}`,
      persons: el.persons || null,
    }))
    this.$set(this, 'personsObject', arr)

    // Ждём, пока DOM обновится
    this.$nextTick(() => {
      // Автовоспроизведение фонового видео при попадании в зону видимости
      const categoryVideo = this.$refs.categoryVideo
      if (categoryVideo) {
        const observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              categoryVideo.play().catch(() => {})
            } else {
              categoryVideo.pause()
            }
          })
        }, { threshold: 0.1 }) // 10% видимости
        observer.observe(categoryVideo)
      }

      // Воспроизведение видео в карточках при наведении
      document.querySelectorAll('.persons__date_person_frame').forEach(frame => {
        const video = frame.querySelector('.frame__video')
        if (!video) return

        frame.addEventListener('mouseenter', () => {
          video.play().catch(() => {})
        })

        frame.addEventListener('mouseleave', () => {
          video.pause()
          video.currentTime = 0
        })

        // Для мобильных — запуск при тапе
        frame.addEventListener('touchstart', () => {
          video.play().catch(() => {})
        })
      })
    })
  },

  computed: {
    ...mapGetters(['category', 'persons']),
    currentLocale() {
      return Trans.currentLocale.trim()
    },
    activeCategory() {
      return this.category
    },
    currentID() {
      return this.$route.params.id
    },
    pageCount() {
      return this.persons.count
    },
    yearOptions() {
      function years(arr, i, min) {
        if (i < min) {
          return arr
        }
        arr.push({ text: i, value: i })
        return years(arr, --i, min)
      }
      let arr = new Array()
      arr.push({ text: 'Год', value: '' })
      let year = new Date().getFullYear()
      arr = years(arr, year, this.yearMin)
      return arr
    },
    selectedYear() {
      if (!this.$route.params.selectedYear) {
        return { text: 'Год', value: '' }
      }
      return this.$route.params.selectedYear
    },
    selectedMonth() {
      if (!this.$route.params.selectedMonth) {
        return { text: 'Месяц', value: '' }
      }
      return this.$route.params.selectedMonth
    },
  },
  methods: {
    ...mapActions(['getCategory', 'filterCategory']),
    filterClick(txt) {
      if (this.$gtm) {
        this.$gtm.push({
          event: 'wall_category_filter',
          param_value: this.helpers.stripHtml(txt),
        })
      }
    },
    getPersons(more) {
      if (this.$gtm && !more) {
        this.$gtm.push({
          event: 'wall_category_find_btn',
        })
      } else if (this.$gtm && more) {
        this.$gtm.push({
          event: 'wall_more',
        })
      }
      if (this.page === 0) {
        this.personsList = null
      }
      this.page++
      return this.filterCategory({
        id: this.currentID,
        page: this.page,
        pageSize: this.pageSize,
        year: this.selectedYear.value,
        month: this.selectedMonth.value,
        name: this.searchName,
      }).then(() => {
        this.personsList = this.persons.results
      })
    },
    searchPersons() {
      if (this.searchName && this.searchName.length < 3) {
        this.nameError = true
        setTimeout(() => {
          this.nameError = false
        }, 1000)
        return
      }
      this.page = 0
      this.getPersons()
    },
    personDetails(item) {
      this.$router.push({
        name: 'SuccessPerson',
        params: {
          locale: this.currentLocale,
          id: item.id,
          categoryID: this.currentID,
          date: `${item.nomination_date.split('-')[1]}-${
            item.nomination_date.split('-')[0]
          }`,
        },
      })
      if (this.$gtm) {
        this.$gtm.push({
          event: 'wall_user_card',
          param_value: this.helpers.stripHtml(item.name),
        })
      }
    },
  },
  watch: {
    selectedYear: {
      deep: true,
      handler() {
        this.page = 0
      },
    },
    selectedMonth: {
      deep: true,
      handler() {
        this.page = 0
      },
    },
    searchName() {
      this.page = 0
      if (!this.searchName.length) {
        this.personsList = null
      }
    },
  },
}
</script>

<style scoped>
.category__persons_null {
  font-family: 'Jost';
  font-style: normal;
  font-weight: normal;
  font-size: 36px;
  line-height: 52px;
  text-align: center;
  color: #ffffff !important;
}
.category__persons_empty {
  position: relative;
  font-family: 'Jost';
  font-style: normal;
  font-weight: normal;
  font-size: 24px;
  line-height: 28px;
  text-align: center;
  z-index: 10;
  color: #ffffff !important;
}
.category__background {
  position: absolute;
  width: 100%;
  height: 100%;
  mix-blend-mode: overlay;
  background: #ffffff;
}
.category__video {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
  object-fit: cover;
  opacity: 0.5;
}
.panel__button-back {
  display: flex;
  width: fit-content;
  height: auto;
  justify-content: flex-start;
  align-items: center;
  font-size: 18px;
  line-height: 26px;
  cursor: pointer;
  color: inherit !important;
}
.panel__button-back:hover {
  opacity: 0.75;
}
.panel__button-back_arrow {
  width: 17px;
  height: 16px;
  margin-right: 18px;
  display: flex;
  align-items: center;
}
.category {
  position: relative;
  width: 100%;
  min-height: 100vh;
  background: #0e0e0e;
  font-family: 'Jost', sans-serif;
  font-style: normal;
  font-weight: normal;
  color: #ffffff !important;
  z-index: 10;
}
.category__wrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 100vh;
  margin: 0 auto;
  box-sizing: border-box;
  padding: 50px 135px 0px 135px;
  object-position: center;
  object-fit: fill;
  z-index: 10;
}
.category__panel {
  margin-top: 35px;
  width: 100%;
  box-sizing: border-box;
  padding: 45px 45px 35px 45px;
  display: flex;
  flex-direction: column;
  z-index: 10;
}
.panel__title {
  margin-top: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.panel__title_text {
  font-size: 52px;
  line-height: 75px;
  color: #ecd593;
  margin-right: 30px;
}
.panel__title_img {
  display: block;
  width: 90px;
  height: 90px;
  object-fit: cover;
  object-position: center;
}
.category__persons_block {
  margin-top: 15px;
  margin-bottom: 130px;
  box-sizing: border-box;
  width: 100%;
  box-sizing: border-box;
  padding: 30px 0px 75px 0px;
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 10;
}
.category__persons {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  gap: 45px;
}
.persons__date {
  width: 100%;
  /* border-bottom: 1px solid #fff;
  padding-bottom: 16px; */
}
.persons__button {
  margin-left: auto;
  margin-top: auto;
  margin-bottom: auto;
  width: fit-content;
  padding: 8px 100px;
  height: 48px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #ecd593;
  font-size: 16px;
  line-height: 16px;
  text-align: center;
  color: #2f2f2f;
  cursor: pointer;
  -moz-user-select: none;
  -webkit-user-select: none;
  user-select: none;
}
.persons__button:hover {
  opacity: 0.75;
}
.persons__date_text {
  text-align: center;
  font-size: 36px;
  line-height: 52px;
  margin-right: 30px;
}
.persons__date_persons {
  margin-top: 32px;
  display: grid;
  width: 100%;
  grid-template-columns: repeat(5, 1fr);
  column-gap: 10px;
  row-gap: 10px;
}
.persons__date_person {
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: rgba(0, 0, 0, 1);
  box-sizing: border-box;
  padding: 22px 15px 32px 15px;
  cursor: pointer;
  overflow: hidden;
}
.frame__video {
  position: absolute;
  display: none;
  width: 225px;
  height: 225px;
  z-index: 0;
  object-fit: cover;
}
.persons__date_person:hover .frame__video {
  display: block;
}
.persons__date_person_frame {
  position: relative;
  width: 145px;
  height: 145px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 2px solid #ff8546;
  box-sizing: border-box;
  border-radius: 50%;
}
.persons__date_person_img {
  width: 115px;
  height: 115px;
  border-radius: 50%;
  object-fit: cover;
  object-position: center;
  z-index: 1;
}
.persons__date_person_logo {
  position: absolute;
  width: 46px;
  height: 46px;
  bottom: 0;
  right: 0;
  border-radius: 50%;
  object-fit: cover;
  object-position: center;
  z-index: 1;
}
.persons__date_person_place {
  margin-top: 8px;
  font-weight: 300;
  font-size: 12px;
  line-height: 17px;
  text-align: center;
  color: #777777;
  z-index: 1;
}
.persons__date_person_name {
  margin-top: 4px;
  font-size: 15px;
  line-height: 21px;
  z-index: 1;
}
.category__button_load {
  margin-top: 55px;
  width: 249px;
  height: 48px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #ecd593;
  font-size: 16px;
  line-height: 16px;
  text-align: center;
  color: #2f2f2f;
  cursor: pointer;
  -moz-user-select: none;
  -khtml-user-select: none;
  -webkit-user-select: none;
  user-select: none;
}
.category__button_load:hover {
  opacity: 0.75;
}
.category__search-panel {
  padding: 32px 45px;
  box-sizing: border-box;
  width: 100%;
  z-index: 1;
  display: grid;
  grid-template-columns: 3fr 1fr;
  column-gap: 10px;
  background-color: rgba(0, 0, 0, 0.7);
}
select.select-panel__year {
  position: relative;
  width: 100%;
  height: 48px;
  background: transparent;
  border: 1px solid #2f2f2f;
  box-sizing: border-box;
  color: #ffffff;
  font-family: 'Jost';
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 16px;
  padding: 0 22px;
  cursor: pointer;
  appearance: none;
  background: url('~@/assets/img/success-ladder/select_arrow.png') no-repeat
    right;
  background-position-x: calc(100% - 22px);
}
select.select-panel__year option {
  background: #0e0e0e;
}
.select-panel_name {
  width: 100%;
  height: 48px;
  box-sizing: border-box;
  padding: 16px 22px;
  background: transparent;
  font-family: 'Jost';
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 16px;
  color: #ffffff !important;
  background: url('~@/assets/img/success-ladder/search.png') no-repeat right !important;
  transition: none !important;

  background-position-x: calc(100% - 22px);
  outline: none;
  border: 1px solid #2f2f2f;
  cursor: pointer;
}
input.select-panel_name {
  transition: none !important;
}
::placeholder {
  color: #ffffff;
  opacity: 1;
}
:-ms-input-placeholder {
  color: #ffffff;
}
.select-panel_button {
  width: 100%;
  height: 48px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #ecd593;
  font-size: 16px;
  line-height: 16px;
  text-align: center;
  color: #2f2f2f;
  cursor: pointer;
  -moz-user-select: none;
  -khtml-user-select: none;
  -webkit-user-select: none;
  user-select: none;
}
.select-panel_button:hover {
  opacity: 0.75;
}
.select-panel_button_disabled {
  opacity: 0.5;
  pointer-events: none;
}

.select-panel_error {
  color: red;
  border-color: red;
}

@media screen and (max-width: 1220px) {
  .category__wrapper {
    width: 100%;
    padding: 30px;
  }
  .category__persons {
    grid-template-columns: repeat(1, 1fr);
  }
  .category__search-panel {
    grid-template-rows: 48px 48px;
    row-gap: 10px;
    grid-template-columns: 1fr;
  }
  /* #panel1 {
    grid-row-start: 1;
    grid-row-end: 2;
    grid-column-start: 1;
    grid-column-end: 6;
  }
  #panel2 {
    grid-row-start: 1;
    grid-row-end: 2;
    grid-column-start: 6;
    grid-column-end: 11;
  }
  #panel3 {
    grid-row-start: 2;
    grid-row-end: 3;
    grid-column-start: 1;
    grid-column-end: 7;
  }
  #panel4 {
    grid-row-start: 2;
    grid-row-end: 3;
    grid-column-start: 7;
    grid-column-end: 11;
  } */
  .persons__date_persons {
    grid-template-columns: repeat(3, 1fr);
  }

  @media screen and (max-width: 743px) {
    .category__wrapper {
      width: 100%;
      padding: 60px 15px;
    }
    .category__persons {
      grid-template-columns: repeat(1, 1fr);
    }
    .category__search-panel {
      grid-template-rows: 48px 48px;
      row-gap: 10px;
      grid-template-columns: 1fr;
    }

    .persons__date_text {
      margin-right: 0;
    }
    .persons__button {
      padding: 8px 16px;
      width: 100%;
      margin: 16px auto 0;
    }
    /* #panel1 {
      grid-row-start: 1;
      grid-row-end: 2;
      grid-column-start: 1;
      grid-column-end: 2;
    }
    #panel2 {
      grid-row-start: 1;
      grid-row-end: 2;
      grid-column-start: 2;
      grid-column-end: 3;
    }
    #panel3 {
      grid-row-start: 2;
      grid-row-end: 3;
      grid-column-start: 1;
      grid-column-end: 3;
    }
    #panel4 {
      grid-row-start: 3;
      grid-row-end: 4;
      grid-column-start: 1;
      grid-column-end: 3;
    } */
    .persons__date_persons {
      grid-template-columns: repeat(1, 1fr);
    }
    .category__panel {
      padding: 35px 15px;
    }
    .panel__title_text {
      font-size: 24px;
      line-height: 35px;
    }
    .panel__title_img {
      width: 70px;
      height: 70px;
    }
  }
}
</style>
